<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card :title="'Manage Leave Settings'" class="">
                <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(onClickSave)">
                        <div class="vx-row">

                            <div class="w-full vx-col mb-4" v-for="(item, index) in generalSettings" :key="index">
                                <small>{{ item.label }}</small>
                                <ValidationProvider :name="`${index}-${item.name}`" rules="required" v-slot="{ errors }"
                                    :vid="`${index}-${item.name}`"  v-if="item.type === 'text' || item.type === 'integer'">
                                    <vs-input
                                        v-model="item.value" :type="item.type" class="w-full" :name="`${index}-${item.name}`"></vs-input>
                                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                                </ValidationProvider>

                                <YesNoToggle v-if="item.type === 'boolean'" v-model="item.value" />

                            </div>

                            <div class="w-full vx-col mb-4" v-if="leaveTypeSettings.length">
                                <small>Which leave types should be deducted from the annual leave balance?</small>
                                <table class="w-full mt-2 border-collapse">
                                    <thead>
                                        <tr class="border-b text-left">
                                            <th class="py-2 pr-4 text-sm">Leave Type</th>
                                            <th class="py-2 text-sm">Deducted from Annual Leave</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="border-b">
                                            <td class="py-2 pr-4 text-sm">Annual Leave</td>
                                            <td class="py-2 text-sm text-gray-600">Always</td>
                                        </tr>
                                        <tr class="border-b" v-for="item in leaveTypeSettings" :key="item.name">
                                            <td class="py-2 pr-4 text-sm">{{ leaveTypeLabel(item.name) }}</td>
                                            <td class="py-2"><YesNoToggle v-model="item.value" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button button="submit" class="ml-auto mt-2" v-can="'edit-staff-leaves'">
                                Save Changes
                            </vs-button>
                        </div>
                    </form>
                </ValidationObserver>
            </vx-card>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@/mixins/ErrorMessages'
import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"

import { RepositoryFactory } from '@/repository/RepositoryFactory';
const LeaveRepository = RepositoryFactory.get('leave');

export default {
    name: "ManageLeaveSettings",
    data() {
        return {
            form: []
        }
    },
    components: {
        YesNoToggle
    },
    computed: {
        generalSettings() {
            return this.form.filter((x) => !this.isLeaveTypeSetting(x.name))
        },
        leaveTypeSettings() {
            return this.form.filter((x) => this.isLeaveTypeSetting(x.name))
        }
    },
    async mounted() {
        await this.fetchData()
    },
    mixins: [ErrorMessages],
    methods: {
        isLeaveTypeSetting(name) {
            return /^is_.+_leave_calculated$/.test(name)
        },
        // e.g. is_sick_leave_calculated => Sick Leave
        leaveTypeLabel(name) {
            return name
                .replace(/^is_|_calculated$/g, '')
                .split('_')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
        },
        async fetchData() {
            this.$vs.loading();
            try {
                const { data } = (await LeaveRepository.getLeaveSettings()).data
                this.form = []

                const keys = Object.keys(data);
                for (const key of keys) {
                    data[key].elements.forEach((x) => {
                        this.form.push({ name: x.name, value: x.value, label: x.label, type: x.type })
                    })
                }

            } catch (error) {
                this.convertAndNotifyError(error);
            } finally {
                this.$vs.loading.close()
            }
        },
        async onClickSave() {
            try {
                let payload = this.form.reduce((obj, item) => {
                    obj[item.name] = item.value;
                    return obj;
                }, {});
                await LeaveRepository.updateLeaveSettings(payload);
                await this.fetchData()
            } catch (error) {

            }
        }
    }
}
</script>
<style lang="">

</style>